
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M16.466 17.2c1.952 0 3.534-1.594 3.534-3.56a3.555 3.555 0 00-2.825-3.488c.007-.102.012-.205.012-.31C17.187 7.357 15.75 5 12.717 5c-2.5 0-3.391 1.44-4.086 3.019a2.215 2.215 0 00-1.447-.536 2.247 2.247 0 00-2.206 2.64A3.553 3.553 0 002 13.64c0 1.966 1.582 3.56 3.533 3.56h5.47a.746.746 0 01-.003-.057v-2.729l-.293.293a1 1 0 01-1.414-1.414l2-2a1 1 0 011.414 0l2 2a1 1 0 01-1.414 1.414L13 14.414v2.729c0 .02 0 .038-.002.057h3.468z"}})])
          )
        }
      }
    